<div class="recall">
    <header>
        <p>Recall</p>
        <div>
           <label class="toggle-switch">
                <input type="checkbox" (change)="onToggleCheckbox([EntityModelConfiguration.RecallAssignedTask, EntityModelConfiguration.RecallValidatedTask])" [checked]="isChecked([EntityModelConfiguration.RecallAssignedTask, EntityModelConfiguration.RecallValidatedTask])" />
                <span class="switch-slider"></span>
            </label>
            <button>
                <img src="../../../../../assets/icons/pencil.svg" />
            </button>
            <button>
                <img src="../../../../../assets/icons/delete-trash-can.svg" />               
            </button>
        </div>
    </header>
    <div class="body">
        <label>        
            <input type="checkbox" (change)="onToggleCheckbox([EntityModelConfiguration.RecallAssignedTask])" [checked]="isChecked([EntityModelConfiguration.RecallAssignedTask])" />
            <span>Assigned Task</span>
        </label>
        <label>        
            <input type="checkbox" (change)="onToggleCheckbox([EntityModelConfiguration.RecallValidatedTask])" [checked]="isChecked([EntityModelConfiguration.RecallValidatedTask])" />
            <span>Validated Task</span>
        </label>
    </div>
</div>